import { Material } from "../../Types/state/masterdata";

export interface IState {
  material: Material[];
  materialCount: number;
}

type Action = any;

export const materialReducer = (
  state: IState = {
    material: [],
    materialCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_MATERIAL":
      return {
        ...state,
        material: action?.payload?.page == 1 ? action?.payload?.data : [...state?.material, ...action?.payload?.data],
        materialCount: action?.payload?.count,
      };
    case "UPDATE_MATERIAL":
      return {
        ...state,
        material: state?.material?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_MATERIAL":
      return {
        ...state,
        material: state?.material?.filter((elem: any) => elem?._id !== action?.payload),
      };
    default:
      return state;
  }
};
